import timeZone from 'moment-timezone';
import moment from 'moment/moment.js';

const toTimestamp = (value) => {
	if (value == null || value === '') return NaN;
	if (typeof value === 'object' && value.$date != null) return new Date(value.$date).getTime();
	if (typeof value === 'object' && typeof value.toDate === 'function') return value.toDate().getTime();
	if (typeof value === 'object' && value._isAMomentObject) return value.valueOf();
	return new Date(value).getTime();
};

/** 返回第一个可解析的日期值，否则 null */
export function pickValidDate(...candidates) {
	for (const value of candidates) {
		if (value == null || value === '') continue;
		const t = toTimestamp(value);
		if (!Number.isNaN(t)) return value;
	}
	return null;
}

function formatDate(date) {
	const valid = pickValidDate(date);
	if (!valid) return '-';
	return timeZone.tz(moment(valid), 'Asia/Shanghai').format('YYYY-MM-DD HH:mm');
}

export default formatDate;
